export function lowerFirst(text: string) {
	return text[0].toLowerCase() + text.slice(1);
}
